import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category",
    title: "全集剧集播放",
    desc: "1 - 24 集分集入口，封面、集数与首播时间一览，想看哪集点哪集。",
    icon: "ri-play-list-2-line",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20still%20of%20a%20film%20strip%20and%20vintage%20cinema%20seats%20with%20warm%20amber%20light%2C%20deep%20warm%20orange%20color%20grading%2C%20gentle%20film%20grain%2C%20soft%20shadows%2C%20elegant%20editorial%20photography&width=900&height=600&seq=young-mother-entry01&orientation=landscape",
    cta: "进入播放列表",
  },
  {
    to: "/plot",
    title: "剧情介绍与解析",
    desc: "整体剧情梗概、主要角色介绍与关键剧情节点时间线，一次看懂全剧脉络。",
    icon: "ri-book-open-line",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20still%20of%20an%20open%20script%20book%20with%20warm%20desk%20lamp%20light%20and%20coffee%20cup%2C%20deep%20warm%20amber%20color%20grading%2C%20gentle%20film%20grain%2C%20soft%20shadows%2C%20cozy%20editorial%20photography&width=900&height=600&seq=young-mother-entry02&orientation=landscape",
    cta: "阅读剧情介绍",
  },
];

export default function QuickEntries() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative block rounded-lg overflow-hidden h-[220px] md:h-[260px] cursor-pointer"
          >
            <img
              src={entry.image}
              alt={`年轻的母亲 ${entry.title}`}
              title={`年轻的母亲 ${entry.title}`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-foreground-950/10" />
            <div className="relative z-10 h-full flex flex-col justify-end p-5 md:p-7">
              <span className="flex items-center justify-center w-11 h-11 rounded-md bg-accent-500 text-accent-950 mb-4">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-2">
                {entry.title}
              </h3>
              <p className="text-sm text-background-200 leading-relaxed max-w-md mb-4">
                {entry.desc}
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-400 whitespace-nowrap">
                {entry.cta}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}